import { action, makeObservable, observable } from 'mobx';
import { generateStoreHelpers } from '@bringg-frontend/bringg-web-infra';
import { ActionKey } from '@bringg-frontend/monitoring';

import { View } from '../types';

export type ActionTriggerSourceType = 'tasks' | 'bulk';
export type MonitoringRoot = MonitoringStore;

export const monitoringRootStore = {
	getStore: () => MonitoringStore.instance,
	clearStore: () => MonitoringStore.clear()
};

export const { useStoreContext: useMonitoringRootStore, withRootStore: withMonitoringRootStore } =
	generateStoreHelpers(monitoringRootStore);

class MonitoringStore {
	private static _instance?: MonitoringStore;
	openModals: {
		[actionKey in ActionKey]: { actionTriggerSource: ActionTriggerSourceType; isOpen: boolean; props?: any };
	} = null;
	view: View;
	initDataLoaded = false;

	public static get instance(): MonitoringStore {
		if (!MonitoringStore._instance) {
			MonitoringStore._instance = new MonitoringStore();
		}

		return MonitoringStore._instance;
	}

	constructor() {
		makeObservable(this, {
			openModals: observable,
			toggleModalVisibility: action,
			view: observable,
			initDataLoaded: observable,
			setInitDataLoaded: action,
			setView: action
		});
	}

	static clear() {
		if (MonitoringStore._instance) {
			MonitoringStore._instance = undefined;
		}
	}

	setInitDataLoaded = (isLoaded: boolean) => {
		this.initDataLoaded = isLoaded;
	};

	toggleModalVisibility = (actionKey: ActionKey, isOpen: boolean, source?: ActionTriggerSourceType, props = {}) => {
		this.openModals = { ...this.openModals, [actionKey]: { isOpen, actionTriggerSource: source, props: props } };
	};

	closeModal = (actionKey: ActionKey) => {
		this.openModals = { ...this.openModals, [actionKey]: { isOpen: false } };
	};

	getModalParams = actionKey => {
		return this.openModals?.[actionKey]?.props;
	};

	isModalOpen = (actionKey: ActionKey): boolean => {
		return this.openModals?.[actionKey]?.isOpen;
	};

	modalSourceType = (actionKey: ActionKey) => {
		return this.openModals?.[actionKey]?.actionTriggerSource;
	};

	setView = (view: View) => {
		this.view = view;
	};
}

export default MonitoringStore;
